import React, { createContext, useContext, useState } from 'react';

type EvidenceData = {
    ada_ref?: string;
    folio_no?: string;
};

type EvidenceContextType = {
    evidenceType: 'ada' | 'comment' | undefined;
    setEvidenceType: React.Dispatch<React.SetStateAction<'ada' | 'comment' | undefined>>;
    evidenceData: EvidenceData;
    setEvidenceData: React.Dispatch<React.SetStateAction<EvidenceData>>;
    getEvidence: () => EvidenceData; // Method to get evidence data
};

const EvidenceContext = createContext<EvidenceContextType | undefined>(undefined);

export const EvidenceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [evidenceType, setEvidenceType] = useState<'ada' | 'comment' | undefined>(undefined);
    const [evidenceData, setEvidenceData] = useState<EvidenceData>({});

    const getEvidence = () => {
        return evidenceData; // Return the current evidence data
    };

    return (
        <EvidenceContext.Provider value={{ evidenceType, setEvidenceType, evidenceData, setEvidenceData, getEvidence }}>
            {children}
        </EvidenceContext.Provider>
    );
};

export const useEvidence = () => {
    const context = useContext(EvidenceContext);
    if (context === undefined) {
        throw new Error('useEvidence must be used within an EvidenceProvider');
    }
    return context;
};
